import { render, staticRenderFns } from "./external-id.vue?vue&type=template&id=3fcbbc2b&"
import script from "./external-id.vue?vue&type=script&lang=ts&"
export * from "./external-id.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports